import AttendanceService from "../../services/AttendanceService";
import {
  MARK_ATTENDANCE_REQUEST,
  MARK_ATTENDANCE_SUCCESS,
  MARK_ATTENDANCE_FAILURE,
  RESET_ATTENDANCE_STATE,
} from "./actionTypes";

const markAttendanceRequest = () => ({ type: MARK_ATTENDANCE_REQUEST });
const markAttendanceSuccess = (attendType) => ({
  type: MARK_ATTENDANCE_SUCCESS,
  payload: attendType,
});
const markAttendanceFailure = (error) => ({
  type: MARK_ATTENDANCE_FAILURE,
  payload: error,
});

export const resetAttendanceState = () => ({ type: RESET_ATTENDANCE_STATE });

/**
 * Thunk: grabs the device geolocation, then posts a Check In / Check Out
 * record for the scanned location (lid) and branch (bid).
 */
export const markAttendance =
  ({ attendType, lid, bid, overNight }) =>
  async (dispatch) => {
    dispatch(markAttendanceRequest());
    try {
      const position = await AttendanceService.getCurrentPosition();

      const result = await AttendanceService.postAttendance({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        lid,
        bid,
        attendType,
        overNight,
      });

      if (!result.responceType) {
        throw new Error(result.responceMessage || "Could not record attendance.");
      }

      dispatch(markAttendanceSuccess(attendType));
      return true;
    } catch (err) {
      const message = err?.message || "Could not record attendance.";
      dispatch(markAttendanceFailure(message));
      return false;
    }
  };
